<h1 mat-dialog-title>{{ systemControlDetailsTitle }}</h1>
<div mat-dialog-content>
  <pre>{{ details }}</pre>
</div>
<div mat-dialog-actions>
  <button mat-button mat-dialog-close>Close</button>
</div>
